import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages(
    'pages.RequestFormPage.NetSuiteBillPaymentRequestForm.NetSuiteBillPaymentBillsSection.AddBillsPopup',
    {
        title: 'Add bills',
        addButtonText: 'Add',
        referenceColumnName: 'Reference',
        transactionIdColumnName: 'Transaction',
        dateDueColumnName: 'Date due',
        typeColumnName: 'Type',
        originalAmountColumnName: 'Original amount',
        amountDueColumnName: 'Amount due',
        currencyColumnName: 'Currency',
        discountDateColumnName: 'Discount date',
        discountAvailableColumnName: 'Discount available',
        amountLabel: 'Total amount of selected Bills:',
    }
);
